import dayjs from "dayjs";

import { ModelsCampaignV2Model } from "@/schemas";
import { CampaignFormValues } from "@/shared/lib/validation/schemas";
import { DATE } from "@/shared/model/const/services";

const getEditableCampaignStatus = (status?: string): CampaignFormValues["status"] => {
    if (status === "Active" || status === "Paused") return status;
    return undefined;
};

export const makeFormRequest = (campaign: ModelsCampaignV2Model): CampaignFormValues => {
    return {
        ...campaign,
        auditory_uuids: campaign.auditories
            ?.filter((auditory): auditory is { uuid: string } => !!auditory.uuid)
            .map((auditory) => auditory.uuid),
        daily_budget_const: campaign.daily_budget_const || 0,
        all_budget_const: campaign.all_budget_const || 0,
        name: campaign.name || "",
        skip_rewarded_ad: campaign.skip_rewarded_ad || "UnsetRewardedType",
        skip_coppa: campaign.skip_coppa || "Unset",
        bet_cpm: campaign.bet_cpm || 0,
        app_uuid: campaign.target?.app?.uuid || "",
        target_id: campaign.target?.uuid || "",
        tracking_link_id: campaign.tracking_link?.uuid || "",
        contract_uuid: campaign.contract?.uuid || "",
        objective: campaign.objective || "CPI",
        bet_cpi: campaign.bet_cpi ? campaign.bet_cpi : undefined,
        start_date: campaign.start_date ? dayjs(campaign.start_date).format(DATE.FORMAT) : null,
        end_date: campaign.end_date ? dayjs(campaign.end_date).format(DATE.FORMAT) : undefined,
        status: getEditableCampaignStatus(campaign.status),
    };
};
